module.exports = __webpack_public_path__ + "img/std-klagenfurt.52f5d374.png";